import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'app/configs/api';
import axios from 'axios';

const initialState = {
  isDocument: false,
  data: [],
  countDocument: null,
};

export const fetchMyDocuments = createAsyncThunk(
  'localNormativeActs/fetchMyDocuments',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await axios.get(API.getMyDocument);
      const data = res.data;
      dispatch(setDocs(data));
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const localNormativeActsSlice = createSlice({
  name: 'localNormativeActs',
  initialState,
  reducers: {
    setDocs: (state, action) => {
      const docs = action.payload || [];
      state.data = docs;
      state.countDocument = docs.length;
      state.isDocument = docs.length > 0;
    },
  },
});

export const { setDocs } = localNormativeActsSlice.actions;
export default localNormativeActsSlice.reducer;
